module.exports = __webpack_public_path__ + "img/solution_apartment_sys.c4f31bea.jpg";